import { faChevronDown, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EmptyList from 'components/common/EmptyList';
import Flex from 'components/common/Flex';
import TaskTemplateAssociateModal from 'components/modals/TaskTemplateAssociateModal';
import NewTaskCard from 'components/tasks/NewTaskCard';
import TaskCard from 'components/tasks/TaskCard';
import { useEffect, useState } from 'react';
import { Button, ButtonGroup, Dropdown, ProgressBar } from 'react-bootstrap';
import TicketTasksService from 'services/TicketTasks.service';

const TicketTasks = ({
  ticketId,
  ticketStatus,
  refreshLogs,
  onCountChange
}) => {
  const ticketIsCompleted =
    ticketStatus === 'COMPLETED' || ticketStatus === 'CLOSED' || ticketStatus?.deleted;

  const [tasks, setTasks] = useState({});
  const [filters, setFilters] = useState({
    page: 0,
    size: 20
  });
  const [isEmptyList, setIsEmptyList] = useState(true);
  const [completedTasks, setCompletedTasks] = useState(0);
  const [totalTasks, setTotalTasks] = useState(0);
  const [showNewTaskForm, setShowNewTaskForm] = useState(false);
  // State to differentiate between regular tasks and group titles
  const [isGroupTitle, setIsGroupTitle] = useState(false);
  const [showTemplateModal, setShowTemplateModal] = useState(false);

  useEffect(() => {
    list();
  }, [ticketId]);

  useEffect(() => {
    if (onCountChange && tasks) {
      const totalCount = tasks.length;
      onCountChange(totalCount);
    }
  }, [tasks]);

  const list = async () => {
    if (!ticketId) return;
    const response = await TicketTasksService.list(ticketId);

    if (Array.isArray(response)) {
      setTasks(response);
      setIsEmptyList(response.length > 0 ? false : true);
      setCompletedTasks(
        response.filter(task => task.status && !task.isGroupTitle).length
      );
      setTotalTasks(response.filter(task => !task.isGroupTitle).length);
    }
  };

  const handleAddTaskClick = () => {
    setIsGroupTitle(false);
    setShowNewTaskForm(true);
  };

  const handleGroupTitleClick = () => {
    setIsGroupTitle(true);
    setShowNewTaskForm(true);
  };

  const handleCancelNewTask = () => {
    setShowNewTaskForm(false);
  };

  const handleTaskAdded = () => {
    setShowNewTaskForm(true);
    list();
    if (refreshLogs) {
      refreshLogs();
    }
  };

  const handleTemplateClick = () => {
    setShowTemplateModal(true);
  };

  const handleTemplateModalClose = () => {
    setShowTemplateModal(false);
  };

  const handleTemplateAssociated = () => {
    list(); // Recarrega a lista de tarefas
    if (refreshLogs) {
      refreshLogs();
    }
  };

  return (
    <>
      <TaskTemplateAssociateModal
        show={showTemplateModal}
        onHide={handleTemplateModalClose}
        ticketId={ticketId}
        onTemplateAssociated={handleTemplateAssociated}
        refreshTasks={list}
      />
      <header className="mb-4">
        <Flex className={'w-100'} justifyContent="between" alignItems="center">
          <Flex alignItems={'center'}>
            <h3 className="m-0">Tarefas</h3>

            <ProgressBar
              now={(completedTasks / totalTasks) * 100 || 0}
              variant="success"
              className="ms-3 me-2"
              style={{ width: '250px', height: '6px' }}
            />

            <small className="fw-medium">
              {completedTasks} de {totalTasks} concluído
              {totalTasks > 0
                ? ` (${((completedTasks / totalTasks) * 100).toFixed(0)}%)`
                : ''}
            </small>
          </Flex>

          <Dropdown
            as={ButtonGroup}
            align={'end'}
            className="btn-reveal-trigger"
          >
            <Button
              variant="primary"
              size="sm"
              onClick={handleAddTaskClick}
              disabled={ticketIsCompleted || showNewTaskForm}
              style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
            >
              <FontAwesomeIcon icon={faPlus} className="me-1" />
              Adicionar tarefa
            </Button>
            <Dropdown.Toggle
              variant="primary"
              id="dropdown-basic"
              className="px-2"
              style={{
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0
              }}
              disabled={ticketIsCompleted || showNewTaskForm}
            >
              <FontAwesomeIcon icon={faChevronDown} size="sm" />
            </Dropdown.Toggle>

            <Dropdown.Menu style={{ width: '250px' }}>
              <Dropdown.Item className="w-100" onClick={handleAddTaskClick}>
                <strong className="fs-9 d-block">Tarefa</strong>
                <span
                  className="text-600 w-100 text-break"
                  style={{ whiteSpace: 'normal' }}
                >
                  São atividades específicas que contribuem para a conclusão do
                  ticket
                </span>
              </Dropdown.Item>
              <Dropdown.Item onClick={handleGroupTitleClick}>
                <strong className="fs-9 d-block">Título</strong>
                <span
                  className="text-600 text-break"
                  style={{ whiteSpace: 'normal' }}
                >
                  Insira um título para agrupar visualmente as tarefas
                </span>
              </Dropdown.Item>
              <Dropdown.Item onClick={handleTemplateClick}>
                <strong className="fs-9 d-block">Template de tarefas</strong>
                <span
                  className="text-600 text-break"
                  style={{ whiteSpace: 'normal' }}
                >
                  Selecione manualmente um template para adicionar tarefas ao ticket atual.
                </span>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Flex>
      </header>
      <div>
        {/* Display new task form when adding */}
        {showNewTaskForm && (
          <NewTaskCard
            ticketId={ticketId}
            onCancel={handleCancelNewTask}
            onTaskAdded={handleTaskAdded}
            isGroupTitle={isGroupTitle}
          />
        )}

        {isEmptyList && !showNewTaskForm ? (
          <EmptyList imgSize={250} />
        ) : (
          <>
            <TaskCard
              ticketId={ticketId}
              tasks={tasks}
              refresh={list}
              refreshLogs={refreshLogs}
              ticketIsCompleted={ticketIsCompleted}
            />
          </>
        )}
      </div>
    </>
  );
};

export default TicketTasks;
